<template>
  <div>
    <vue-headful title="In afwachting" />
    <Header page_title="In afwachting" />
    <div class="container-fluid app-body mt-0">
      <div class="">
        <!-- <NotificationContainer /> -->
        <div class="sd-title mini clearfix m-3 mb-4">
          <div class="title-text">
            <svg-icon class="svg-container" icon="suitcase"></svg-icon> In afwachting van reactie
          </div>
        </div>
        <template v-if="pending && pending.length">
          <div id="applicants" class="applicant-overview">
              <template v-if="branch != 3">
                    <ApplicantCard
                      v-for="applicant in pending"
                      :key="applicant.job_applicant_id"
                      :applicant="applicant"
                      :view="true"
                    />
              </template>
              <template v-else>
                  <HealthcareApplicantCard
                      v-for="applicant in pending"
                      :key="applicant.job_applicant_id"
                      :applicant="applicant"
                      :view="true"
                  />
              </template>
          </div>
        </template>
        <template v-else>
          <div class="sd-notif warning"><svg-icon icon="information" class="warning-icon"/> Er zijn geen kandidaten in afwachting.</div>
        </template>
      </div>
    </div>
    <div class="container-fluid app-body mt-0">
      <div class="">
        <!-- <NotificationContainer /> -->
        <div class="sd-title mini clearfix m-3 mb-4">
          <div class="title-text">
            <svg-icon class="svg-container" icon="trash"></svg-icon> Afgewezen kandidaten
          </div>
        </div>
        <template v-if="declined && declined.length">
          <div id="applicants" class="applicant-overview">
              <template v-if="branch != 3">
                  <ApplicantCard
                      v-for="applicant in declined"
                      :key="applicant.job_applicant_id"
                      :applicant="applicant"
                      :view="true"
                  />
              </template>
              <template v-else>
                  <HealthcareApplicantCard
                      v-for="applicant in declined"
                      :key="applicant.job_applicant_id"
                      :applicant="applicant"
                      :view="true"
                  />
              </template>
          </div>
        </template>
        <template v-else>
          <div class="sd-notif warning"><svg-icon icon="information" class="warning-icon"/> Er zijn geen afgewezen kandidaten.</div>
        </template>
      </div>
    </div>
      <Empty v-if="(!pending || !pending.length) && (!declined || !declined.length)" text="Je hebt geen sollicitanten." />
    <div
      v-if="fullscreen_notif == 'comment'"
      class="fullscreen-notif bg-light position-fixed"
    >
      <button
        type="button"
        class="close position-fixed"
        aria-label="Close"
        v-on:click="fullscreen_notif = null"
      >
        <div class="icon-wrapper">
          <i class="material-icons-round">close</i>
        </div>
      </button>
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <div>
              <NotificationContainer />
              <div class="form-group">
                <textarea
                  maxlength="160"
                  class="form-control"
                  :placeholder="
                    'Heb je vragen of opmerkingen over deze vacature? \n(Max. 160 tekens)'
                  "
                  rows="4"
                  spellcheck="false"
                  v-model="comment"
                ></textarea>
              </div>
              <a
                class="btn btn-warning btn-block"
                role="button"
                @click="onSubmitAccept"
                >Doorgaan</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <Hired
      v-model="show_info"
      v-if="hired && show_info"
      :user="hired"
      :show="true"
    />
    <Footer />
  </div>
</template>

<script>
import ApplicantCard from "@/components/Company/ApplicantCard.vue";
import HealthcareApplicantCard from "@/components/Company/HealthcareApplicantCard.vue";

export default {
  data: function() {
    return {
      user: null,
      hired: null,
      show_info: false,
      pending: null,
      declined: null,
      job_applicant_id: 0,
      fullscreen_notif: null,
      comment: "",
        branch: localStorage.getItem("branch")
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.pending = await this.getTokenAPIList("applicants"); // get notifications
      this.declined = await this.getTokenAPIList("applicants/declined"); // get declined applicants

      this.$store.state.loading = false;
    },
    async notifChanged () {
      this.fullscreen_notif = "comment"
      this.$store.dispatch("notification/replace", {}, {
        root: true
      });
    },
    async jobApplicantIdChanged (id) {
      this.job_applicant_id = id;
    },
    async onSubmitAccept () {
      this.$store.state.loading = true;
      this.user = await this.getTokenAPIList("applicant/" + parseInt(this.job_applicant_id));

      await this.acceptApplicant(parseInt(this.job_applicant_id), this.comment).then(() => {
        this.fullscreen_notif = null;
        let temp = {};
        temp["avatar"] = this.user.avatar;
        temp["firstname"] = this.user.firstname;
        temp["name"] = this.user.firstname;
        temp["mobile"] = this.user.mobile;
        temp["email"] = this.user.email;
        temp["dashboard"] = "applicant-dashboard";
        this.hired = temp;
        this.show_info = true;

        this.user = null;
        this.job_applicant_id = 0;
        this.comment = "";
      }).catch(() => {
        this.user = null;
        this.comment = "";
        this.fullscreen_notif = "comment";
      });
    }

  },
  components: {
      HealthcareApplicantCard,
    ApplicantCard
  }
};
</script>

<style scoped>
::v-deep .applicant-link .text.position {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 20px;
}
</style>
